import { RootState } from '@app/store';
import { Invoice } from '@features/company/model/Invoice';

export const selectGetInvoicesState = (state: RootState) => state.company.getInvoicesState;

export const selectInvoices = (state: RootState) => state.company.invoices;

export const selectInvoiceById = (invoiceId: string) => (state: RootState) =>
  state.company.invoices?.find((invoice: Invoice) => invoice.id.toString() === invoiceId);
